export default __webpack_public_path__ + "static/media/chevron-dropdown.26553510.svg";